import React from 'react';
import OTP from 'components/core/OTP/OTP';
import { IFormElementProps } from 'models/form';
import { IFormOtpProps } from 'components/containers/OTP/OTPContent';
import { useForm } from 'react-final-form';
import FormElementWrapper from 'components/formElements/FormElementWrapper';
import { onChangeFormElementComponent } from 'utilities/form';
import { isFunction } from 'lodash-es';

export interface IPassCodeProps extends IFormOtpProps, IFormElementProps {
  onChange: (value: string, index: number) => void;
  showError?: boolean;
  enforceSetModifiedSinceLastBlur?: (value: string, index: number) => boolean | undefined;
}

const PassCode = React.forwardRef(
  (
    {
      input,
      meta,
      onChange,
      showError,
      codeLength,
      enforceSetModifiedSinceLastBlur,
      ...rest
    }: IPassCodeProps,
    ref
  ) => {
    const form = useForm();

    const handleChange = (value: string, index: number): void => {
      const enforceSetModifiedSinceLastBlurRes =
        isFunction(enforceSetModifiedSinceLastBlur) &&
        enforceSetModifiedSinceLastBlur(value, index);
      onChangeFormElementComponent(
        { value, secondParam: index },
        {
          input,
          setModifiedSinceLastBlur: form.mutators.setModifiedSinceLastBlur,
          onChange,
          enforceSetModifiedSinceLastBlur: enforceSetModifiedSinceLastBlurRes
        }
      );
    };

    return (
      <FormElementWrapper
        input={input}
        meta={meta}
        withFixedError={showError}
        disableModifiedMutator
      >
        <OTP
          name={input.name}
          onChange={handleChange}
          ref={ref}
          codeLength={codeLength}
          {...rest}
        />
      </FormElementWrapper>
    );
  }
);

export default PassCode;
